<template>
  <div id="home" :class="tcls">
    <fui-top :user="user" @resetThemes="resetThemes" :themes="tcls" />
    <fui-content ref="fctt"/>
  </div>
</template>

<script>
export default {
  created: function(){
    //this.$loader=document.querySelector("#loader")
    //console.log(this.$loader)
    this.$nextTick( ()=> {
         this.$baseWidth = this.$refs.fctt.$el.clientWidth
         //this.$loader = this.$refs.loader
         //console.log(this.$loader )
    })


    if (!this.user.isLogin){
      this.$getData("login/isLogin", data => {
          $.userState.isLogin = data.rs
          $.userState.name = data.userName
          $.userState.menuList = data.menuList
          if (data.themes) this.tcls = data.themes
        }, false)

      /*$.ajax({
        url: this.$apiUrl + "login/isLogin",
        async: false,
        type: "get",
        success: data => {
          $.userState.isLogin = data.rs
          $.userState.name = data.userName
          $.userState.menuList = data.menuList
          if (data.themes) this.tcls = data.themes
        }
      })*/
    }
    else{
      const themes = window.localStorage.getItem("fui-themes")
      if (themes) this.tcls = themes
    }
    if (!this.user.isLogin) this.$router.push({path:'login'})
      
    //else this.$router.push('welcome')
  },
  methods:{
    resetThemes(className){
      this.tcls = className
      this.$getData("login/resetThemes?themes=" + className, function(){})
    }
  },
  data() {
    return {
      user: $.userState,
      tcls:"fui-black"
    }
  }
}
</script>

